export const DEV_DSN_KEY =
    "https://fbd4bfacb597c3d17b9279d023038e2a@o148878.ingest.us.sentry.io/5733890";
//This key is used for the QA, Staging and Production environments in Sentry
export const PROD_DSN_KEY =
    "https://fef33bc017414f09bcf117882ad6b34a@o148878.ingest.sentry.io/5733890";
